webpackJsonp([160061315090044],{

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _meta = __webpack_require__(16);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var metadata = {
	  title: 'Tarifs | Psychologue clinicienne à Montpellier | Morgane Laroche',
	  description: 'Tarifs. Modalités de paiement. Remboursement des consultations. Retards et Annulations.'
	};
	
	var Tarifs = function Tarifs() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_meta2.default, { title: metadata.title, description: metadata.description }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container container--page' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container__block' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'container__block-title' },
	          'TARIFS'
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'container__content-list u-mb' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'u-bold' },
	              'Fr\xE9quence'
	            ),
	            '\xA0: chaque semaine ou toutes les deux semaines, \xE0 d\xE9finir en fonction de vos besoins et de vos possibilit\xE9s financi\xE8res'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'u-bold' },
	              'Dur\xE9e\xA0de l\u2019entretien'
	            ),
	            ' : environ 1h pour le premier entretien - 45 \xE0 50 min pour les entretiens de suivi'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'u-bold' },
	              'Honoraires'
	            ),
	            '\xA0: 55 euro.',
	            ' ',
	            _react2.default.createElement(
	              'em',
	              null,
	              'Un tarif r\xE9duit peut parfois \xEAtre envisag\xE9 pour les \xE9tudiants, les personnes sans emploi ou ayant de faibles revenus. Celui-ci n\'est pas accord\xE9 de mani\xE8re syst\xE9matique : chaque situation se discute au cas par cas lors du premier entretien.'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container__block' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'container__block-title container__block-title--nomarge' },
	          'Informations pratiques'
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: 'container__block-subtitle' },
	          'Modalit\xE9s de Paiement'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'u-paragraphe u-mb' },
	          'Le r\xE8glement des consultations s\u2019effectue \xE0 l\u2019issue de chaque s\xE9ance, par ch\xE8que ou esp\xE8ces (pas de CB).'
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: 'container__block-subtitle' },
	          'Remboursement'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'u-paragraphe u-mb' },
	          'Certaines mutuelles proposent le remboursement de quelques s\xE9ances. Pour en savoir plus, n\u2019h\xE9sitez pas \xE0 vous renseigner aupr\xE8s de votre mutuelle.'
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: 'container__block-subtitle' },
	          'Retards et Annulations'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'u-paragraphe' },
	          'En cas de retard de la part d\u2019un patient, la s\xE9ance n\u2019est pas prolong\xE9e en compensation.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'En cas d\u2019annulation ou de demande de d\xE9placement d\u2019un rendez-vous, je souhaite \xEAtre pr\xE9venue 48h \xE0 l\u2019avance (jours ouvrables). En de\xE7\xE0 de ce d\xE9lai, la consultation vous sera due et devra \xEAtre r\xE9gl\xE9e la s\xE9ance suivante.'
	        )
	      )
	    )
	  );
	};
	exports.default = Tarifs;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tarifs-js-bce7cee5ae837049f363.js